window.addEventListener('load', function () {

  var inputFields = document.querySelectorAll('.themeForm .hs-input');
  var checkboxContainers = document.querySelectorAll('.themeForm .hs-form-booleancheckbox');


  if (inputFields.length > 0) {
    inputFields.forEach(function (inputField) {
      var placeholder = inputField.getAttribute('placeholder');

      if (placeholder) {
        var placeholderFormatted = placeholder.replace('*', '');
        inputField.setAttribute('aria-label', placeholderFormatted);
      }

      var isRequired = inputField.hasAttribute('required') || inputField.getAttribute('required') === '';

      // if the input field is required, set aria-required to true
      if (isRequired) {
        inputField.setAttribute('aria-required', 'true');
      }

    });
  }

  if (checkboxContainers.length > 0) {
    checkboxContainers.forEach(function (checkboxContainer) {
      var firstSpan = checkboxContainer.querySelector('span');
      if (firstSpan) {
        firstSpan.setAttribute('tabindex', '0');
      }
    });
  }


});
